import { render, staticRenderFns } from "./commodityConversion.vue?vue&type=template&id=b5438664&"
import script from "./commodityConversion.vue?vue&type=script&lang=js&"
export * from "./commodityConversion.vue?vue&type=script&lang=js&"
import style0 from "./commodityConversion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5438664')) {
      api.createRecord('b5438664', component.options)
    } else {
      api.reload('b5438664', component.options)
    }
    module.hot.accept("./commodityConversion.vue?vue&type=template&id=b5438664&", function () {
      api.rerender('b5438664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/commodityConversion.vue"
export default component.exports